export const engagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit =
  "/engagement/:app_group_id/canvas/:workflow_id/content_optimization_launch_limit";
